<template>
  <div v-if="displayGallery" class="d-flex justify-content-center align-items-center mt-4 mx-auto position-absolute" style="z-index: 99999;">
    <ModalRoot
      :images="pictures"
      :prestations="prestations"
      @close="closeModal"
    />
  </div>
</template>

<script>
import ModalRoot from "./ModalRoot.vue";
export default {
  components: {
    ModalRoot,
  },
  props: {
    pictures: Array,
    prestations: Array,
  },
  data() {
    return {
      displayGallery: false
    };
  },

  created() {
    window.addEventListener('openResidenceGallery', this.displayResidanceGalerry);
  },
  beforeDestroy() {
    window.removeEventListener('openResidenceGallery', this.displayResidanceGalerry);
  },

  methods: {
    displayResidanceGalerry() {
      this.displayGallery = true
      document.body.style.overflow = 'hidden';
    },

    getImageUrl(image) {
      return image.imgXL || image.imgLarge || image.img;
    },

    closeModal() {
      this.displayGallery = false
      document.body.style.overflow = 'visible';
    },
  },
};
</script>

<style scoped>
::-webkit-scrollbar {
    display: none;
}
</style>